export const footerText = 'Copyright Community Compass © 2025';
